import request from '@/utils/request';

export const GetConsignmentByVmiId = parameter => request.get('/consignment/get-consignment-by-consignment-site-id', { params: parameter });

export const GetConsignmentList = parameter => request.post('/consignment/select-consignment-by-criterion-bean-vo',  parameter);